// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs--1Jv","breadcrumbs__list":"breadcrumbs__list--JdL","breadcrumbs__item":"breadcrumbs__item--_8l"};